import React from "react";
import "../../OrderComponents/OrderTabs.css";
import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";

import { useEffect } from "react";
import { useLocation, NavLink } from "react-router-dom";
import api from "../../../seller-apis/api";

const StatusUpdatePopup = ({show,handleUnlockClose,updateSatus,leadId,selectedPrice,status,statusObject}) => {
  
  return (
    <Modal className='custom-modal lead-unlock' centered   show={show} onHide={handleUnlockClose}>
    
      <Modal.Body>
        <p className='unlock-title'>{statusObject?.title}</p>
        <p className='unlock-sub-title fs-14'>{statusObject.subTitle?statusObject.subTitle:"Are you sure want to unlock this lead?"}</p>

        <div className='leads-buttons dis-flex my-3 justify-content-center'>
        <Button variant="primary" className='apply-btn flex-center' onClick={()=>updateSatus(leadId,status)}>
          Yes
        </Button>
        <Button className='yes-button' variant="secondary flex-center" onClick={handleUnlockClose}>
          No
        </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default StatusUpdatePopup;
